__turbopack_context__.v({
  "Image": "styles-module__N5H4NW__Image",
  "listItemTransparent": "styles-module__N5H4NW__listItemTransparent",
  "logoImage": "styles-module__N5H4NW__logoImage",
  "menuIcon": "styles-module__N5H4NW__menuIcon",
  "menuIcon_active": "styles-module__N5H4NW__menuIcon_active",
  "open": "styles-module__N5H4NW__open",
  "toggleArrow": "styles-module__N5H4NW__toggleArrow",
  "toggleArrow_closed": "styles-module__N5H4NW__toggleArrow_closed",
  "toggleArrow_open": "styles-module__N5H4NW__toggleArrow_open",
});
